module.exports = __webpack_public_path__ + "static/media/Storm and Sanitary Analysis.4e51664a.png";